import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=081f15d9&scoped=true&"
import script from "./TaskType.vue?vue&type=script&lang=js&"
export * from "./TaskType.vue?vue&type=script&lang=js&"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=081f15d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f15d9",
  null
  
)

export default component.exports